import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Backdrop from "../../UI/Backdrop/Backdrop";
import { AnimatePresence } from "framer-motion";
import { motion } from "framer-motion";

import classes from "./Cart.module.css";
import CartList from "./CartList";
import { useNavigate } from "react-router-dom";
import "animate.css";

const Cart = () => {
  const [isCartVisible, setIsCartVisible] = useState(false);
  const navigate = useNavigate();
  const cartData = useSelector((state) => state.cart.items);
  const [isCartChange, setIsCartChange] = useState(false);
  useEffect(() => {
    /* handle scrolling */
    if (isCartVisible) {
      document.body.style.height = "100vh";
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.height = "";
      document.body.style.overflowY = "";
    }

    /* handle animation when cartData change */
    if (cartData.length > 0) setIsCartChange(true);
    setTimeout(() => {
      setIsCartChange(false);
    }, 2000);
  }, [isCartVisible, cartData]);

  const toggle = () => {
    setIsCartVisible(!isCartVisible);
  };

  const inquireHandler = () => {
    navigate("inquire");
    toggle();
  };
  return (
    <>
      <span
        className={`animate__animated ${classes.cart} ${
          isCartChange ? "animate__bounceIn" : ""
        }`}
        onClick={toggle}
      >
        {cartData.length}
      </span>

      <AnimatePresence
        initial={false}
        exitBeforeEnter={true}
        onExitComplete={() => null}
      >
        {isCartVisible && (
          <motion.div
            className={classes.backdrop}
            onClick={toggle}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className={classes.card} onClick={(e) => e.stopPropagation()}>
              <Icon
                icon="iconoir:cancel"
                color="#363636"
                width="30"
                height="30"
                onClick={toggle}
                className={classes.cancel}
              />
              <h4 className={classes.title}>已選取的商品</h4>
              <div>
                <CartList
                  cart={cartData}
                  inquireHandler={inquireHandler}
                  toggle={toggle}
                />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Cart;
